// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"2319fc65","513":"e118fd8c","703":"027bff8b"}[chunkId] + ".chunk.js";
};